import React, { useMemo } from 'react'
import { Select } from 'antd'
import { useFetchConceptualLabelsQuery } from '../../../../store/apis/conceptual-label.api'
import { isNil } from 'lodash'

const ConceptualLabelSelectParent = ({ value, onChange, disciplineId, disabled, ...rest }) => {
    const { data: allLabels, isFetching } = useFetchConceptualLabelsQuery()
    
    const parentLabels = useMemo(() => {
        if (!allLabels || !disciplineId) return []
        return allLabels.filter(label => label.disciplineId === disciplineId)
    }, [allLabels, disciplineId])

    return (
        <Select
            placeholder="Select a parent label (optional)"
            value={value}
            onChange={onChange}
            loading={isFetching}
            allowClear
            showSearch
            optionFilterProp="children"
            title={isNil(disciplineId) && "Select a discipline first"}
            disabled={disabled || !disciplineId}
            filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
            {...rest}
        >
            {parentLabels?.map(label => (
                <Select.Option key={label.id} value={label.id}>
                    {`${label.visualId} - ${label.name}`}
                </Select.Option>
            ))}
        </Select>
    )
}

export default ConceptualLabelSelectParent 